import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { AppService } from 'app/services/app.service';
import { fuseAnimations } from '@fuse/animations';
import { DatasetService } from 'app/main/components/dataset/services/dataset.service';

import { BaseInputComponent } from '../base-input.component';
import { FormInputViewerService } from '../../form-input-viewer.service';

@Component({
    selector: 'textarea-input',
    templateUrl: './input.component.html',
    animations: fuseAnimations,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextareaInputComponent{

	constructor(
		public inputService: FormInputViewerService
	){}
}
